var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"video-container"},[_c('video',{staticClass:"video",attrs:{"autoplay":"","playsinline":"","loop":""}},[_c('source',{attrs:{"src":_vm.videoBg}})]),_vm._v(" "),_c('v-img',{staticClass:"video-content",attrs:{"src":_vm.imgtop}},[_c('div',{staticClass:"text-center text-h1 white--text"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }